// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://uat-app.igmsurfaces.com/api/v1/',  // not in use
  // cosmosgranitebaseUrl: 'https://uat-backend.cosmossurfaces.com/api/v1/',
  endPoint: 'https://common.cosmossurfaces.com/api/',
  siteKey: '6LdOF20sAAAAABVkzL5OJ3xcgYz1oK0ldbnYMpJv',
  igmBaseUrl: "https://uat-app.igmsurfaces.com/api/v1/",
  mapkey: 'AIzaSyCECNx6YKAjaYfP9Eq7FXAMB1QmjUKvMZk'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
